<template>
    <DCard
        :padding="true"
    >
        <Form
            :domain-tool-settings="domainToolSettings"
            :errors="errors"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Settings/DomainToolSettings/Form'

export default {
    name: 'DomainToolSettingsCreate',
    components: {
        Form
    },
    props: {
        domainToolSettings: {
            type: Object,
            default () {
                return {}
            }
        },
        errors: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    methods: {
        submitData (form) {
            form.post(this.$route('settings.domain-tool-settings.store'))
        }
    }
}
</script>
